import { DeliveryType } from "@omni/types/api/product/bff/shared/enums/deliveryType.enum";
import { StoreType } from "@omni/types/api/store/cloud/shared/enums/storeType.enum";
import { Button } from "@omni/ui/components/Button/button.component";
import { cn } from "@omni/utils/styles";
import { useCallback, useState } from "react";

import { StorePickerModal } from "@/components/Store/StorePicker/storePickerModal.container";
import { StorePickerFeature } from "@/components/Store/StorePicker/types/storePickerFeature.enum";
import { StorePickerType } from "@/components/Store/StorePicker/types/storePickerType.enum";
import { useGranite } from "@/redux/modules/value/translations/translations.provider";

import { useDeliveryItemContext } from "../../context/deliveryItem.context";
import { BoxPromise } from "./boxPromise.component";
import { ItemStock } from "./itemstock.component";

const ClickAndCollectComponent = () => {
    const { t } = useGranite();
    const {
        sku,
        option,
        isLimitedStock,
        infoLink,
        isBoxArticle,
        boxLogisticInformation,
        preferredStore,
        onChangeDeliveryType
    } = useDeliveryItemContext();
    const [isStorePickerOpen, setIsStorePickerOpen] = useState(false);

    // biome-ignore lint/correctness/useExhaustiveDependencies: <TODO>
    const handleOnClose = useCallback(
        () => setIsStorePickerOpen(false),
        [setIsStorePickerOpen]
    );

    if (option.deliveryType !== DeliveryType.ClickAndCollect) {
        return null;
    }

    return (
        <>
            <div className={cn("tw:pl-5.25")}>
                {isLimitedStock && (
                    <p
                        data-test={`deliveryItem-${option.deliveryType}-description`}
                        className={cn("tw:text-sm tw:font-light tw:m-0")}
                    >
                        {t("general.ecommerce.clickAndCollect.limitedStock")}
                    </p>
                )}
                {isBoxArticle && (
                    <BoxPromise
                        data-test={`deliveryItem-${option.deliveryType}-boxPromise`}
                        boxLogisticInformation={
                            boxLogisticInformation ||
                            t(`ecommerce.label.pickup.box.${sku}`)
                        }
                        shopName={preferredStore?.shopName}
                    />
                )}
                {!isBoxArticle && !preferredStore ? (
                    <p
                        data-test={`deliveryItem-${option.deliveryType}-description`}
                        className={cn("tw:text-sm tw:font-light tw:m-0")}
                    >
                        {t("general.ecommerce.clickAndCollect.noStore")}
                    </p>
                ) : (
                    !isBoxArticle &&
                    !!preferredStore?.productAvailability && (
                        <ItemStock
                            data-test={`deliveryItem-${option.deliveryType}-itemStock`}
                            productAvailability={
                                preferredStore?.productAvailability!
                            }
                            shopName={preferredStore?.shopName}
                        />
                    )
                )}
                <Button
                    test={`deliveryItem-${option.deliveryType}-button-showAvailability`}
                    color={"link"}
                    className={cn("tw:p-0")}
                    type="button"
                    onClick={() => {
                        onChangeDeliveryType();
                        setIsStorePickerOpen(true);
                    }}
                >
                    {t(
                        isBoxArticle
                            ? "general.ecommerce.link.box.showStores"
                            : "general.ecommerce.link.showAvailability"
                    )}
                    <i className={cn("las la-angle-right", "tw:mr-1")} />
                </Button>
            </div>
            <StorePickerModal
                isOpen={isStorePickerOpen}
                type={StorePickerType.SELECT}
                storeCode={preferredStore?.code ?? null}
                displayStockLevel={!isBoxArticle}
                infoLink={infoLink}
                fixedFeatures={[StorePickerFeature.BUY_ONLINE_PICKUP_IN_STORE]}
                onSubmit={(_, close) => close?.()}
                onClose={handleOnClose}
                filterStoreType={StoreType.WalkIn}
            />
        </>
    );
};

export { ClickAndCollectComponent };
